module.exports = __webpack_public_path__ + "static/media/fridge.b5be38af.jpg";